require("normalize.css/normalize.css");
require("./styles/index.scss");

import Noise2D from "./utils/simpleNoise";

let simplex = new Noise2D();

const canvas = document.querySelector(".main-canvas");
const ctx = canvas.getContext("2d");

canvas.width = window.innerWidth * window.devicePixelRatio;
canvas.height = window.innerHeight * window.devicePixelRatio;

let time = 0;
const update = () => {
  requestAnimationFrame(update);
  // mouseX = ((Mouse.cursor[0] + 1)/2) * canvas.width
  // mouseY = ((Mouse.cursor[1] + 1)/2) * canvas.height

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = "#000000";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fill();

  let steps = 200;
  let scale = 200;
  let frequency = 200;

  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);

  for (let i = 0; i < 10; i++) {
    ctx.beginPath();
    ctx.strokeStyle = "#FFF";

    for (let x = 0; x < steps; x++) {
      let progress = (x / steps) * 4;
      let angle = 2 * Math.PI * progress * 2;

      let n = simplex.noise4D(time, Math.cos(angle * frequency), Math.sin(angle * frequency), Math.random()) * 800;
      scale = 10 + i * 3 + n;
      ctx.lineTo(Math.cos(angle) * scale, Math.sin(angle) * scale);
    }
    ctx.lineTo(Math.cos(0) * scale, Math.sin(0) * scale);

    ctx.stroke();
    ctx.closePath();
  }

  ctx.restore();

  time += 0.008;
};

requestAnimationFrame(update);
